import { Divider } from '../../../components/Divider';
import { DividedPage } from '../../../components/DividedPage';

export type PaymentsProps = {
	payments: JSX.Element[];
	isRefund?: boolean;
};

export const Payments: React.FC<PaymentsProps> = ({ payments, isRefund }) => (
	<div className="order-payments">
		{isRefund ? (
			<h4 className="text-secondary mb-0">
				Refunded Card{payments.length > 1 ? 's' : ''}
			</h4>
		) : (
			<h4 className="text-primary mb-0">Payment</h4>
		)}

		<Divider my={3} />

		<DividedPage dividerProps={{ my: 2, borderColor: 'light' }}>
			{payments}
		</DividedPage>
	</div>
);
